import { render } from "./DevPageKnowledge.vue?vue&type=template&id=3c78762f"
import script from "./DevPageKnowledge.vue?vue&type=script&lang=js"
export * from "./DevPageKnowledge.vue?vue&type=script&lang=js"
script.render = render

export default script